import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  members: [],
  users: [],
  user: null,
  status: null,
  error: null,
};

export default (state = initialState, action) => {
  let index = -1;
  let members = [];

  switch (action.type) {
    case actionTypes.MEMBERS_GET_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.MEMBERS_GET_ERROR:
      return { ...state, status: action.type, members: [] };

    case actionTypes.MEMBERS_GET_SUCCESS:
    case actionTypes.MEMBERS_SET:
      return { ...state, status: action.type, members: action.members };

    case actionTypes.TEAM_CREATE_SUCCESS:
      if (action.team.members) {
        return { ...state, members: action.team.members };
      } else {
        return state;
      }

    case actionTypes.MEMBER_CREATE_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.MEMBER_CREATE_SUCCESS:
      return {
        ...state,
        status: action.type,
        members: state.members.concat(action.member),
      };

    case actionTypes.MEMBER_CREATE_ERROR:
      return { ...state, status: action.type, error: action.error };

    case actionTypes.MEMBER_ADD:
      return {
        ...state,
        status: action.type,
        members: state.members.concat(action.member),
      };

    case actionTypes.MEMBER_SAVE:
      members = state.members;
      index = R.findIndex(
        (member, i) =>
          member.user_info &&
          action.member.user_info &&
          member.user_info.email === action.member.user_info.email
      )(members);

      if (index !== -1) {
        members[index] = action.member;
      }
      return { ...state, status: action.type, members: members.concat() };

    case actionTypes.MEMBER_REMOVE:
      members = state.members;
      index = R.findIndex(
        (member, i) =>
          member.user_info &&
          action.member.user_info &&
          member.user_info.email === action.member.user_info.email
      )(members);

      if (index !== -1) {
        members = R.remove(index, 1, members);
      }
      return { ...state, status: action.type, members: members.concat() };

    case actionTypes.MEMBER_UPDATE_REQUEST:
    case actionTypes.MEMBER_UPDATE_SUCCESS:
    case actionTypes.MEMBER_UPDATE_ERROR:
    case actionTypes.MEMBER_DELETE_REQUEST:
    case actionTypes.MEMBER_DELETE_SUCCESS:
    case actionTypes.MEMBER_DELETE_ERROR:
      return { ...state, status: action.type };

    case actionTypes.OWNERSHIP_CREATE_SUCCESS:
    case actionTypes.OWNERSHIP_UPDATE_SUCCESS:
    case actionTypes.OWNERSHIP_DELETE_SUCCESS:
      return { ...state, status: action.type };

    case actionTypes.USER_GET_REQUEST:
    case actionTypes.USER_GET_ERROR:
      return { ...state, status: action.type };

    case actionTypes.USER_GET_SUCCESS:
      return { ...state, status: action.type, user: action.user };

    case actionTypes.USERS_GET_REQUEST:
    case actionTypes.USERS_GET_ERROR:
      return { ...state, status: action.type, users: [] };

    case actionTypes.USERS_WITH_REFERRER_ID_GET_REQUEST:
    case actionTypes.USERS_WITH_REFERRER_ID_GET_ERROR:
        return { ...state, status: action.type, users: [] };

    case actionTypes.USERS_WITH_REFERRER_ID_GET_SUCCESS:
      return { ...state, status: action.type, users: action.users };

    case actionTypes.USER_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.user.id))(state.users);
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          user: action.user,
          users: state.users.concat(action.user),
        };
      } else {
        state.users[index] = action.user;
        return {
          ...state,
          status: action.type,
          user: action.user,
          users: [...state.users],
        };
      }

    case actionTypes.PROFILE_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.data.id))(state.users);
      let user = state.user;
      if (index !== -1) {
        state.users[index] = action.data;
      }
      if (user && action.data.id === user.id) {
        user = action.data;
      }
      return { ...state, user, users: [...state.users] };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/users.js